import { clue_data } from "../../data/clues";
import { LocalMethodId } from "../MethodPackManager";
import { FakeLodash } from "../../lib/coreutil/FakeLodash";
export var MethodPack;
(function (MethodPack) {
    function setMeta(pack, meta) {
        pack.author = meta.author;
        pack.description = meta.description;
        pack.name = meta.name;
        pack.default_assumptions = FakeLodash.cloneDeep(meta.default_assumptions);
        pack.default_method_name = meta.default_method_name;
    }
    MethodPack.setMeta = setMeta;
    function meta(pack) {
        return {
            name: pack.name,
            author: pack.author,
            description: pack.description,
            default_assumptions: FakeLodash.cloneDeep(pack.default_assumptions),
            default_method_name: pack.default_method_name
        };
    }
    MethodPack.meta = meta;
    function isEditable(pack) {
        return pack.type == "local" || isEditableDefault(pack);
    }
    MethodPack.isEditable = isEditable;
    function isEditableDefault(pack) {
        return (pack.type == "default" && !pack.is_real_default);
    }
    MethodPack.isEditableDefault = isEditableDefault;
})(MethodPack || (MethodPack = {}));
export var AugmentedMethod;
(function (AugmentedMethod) {
    function create(method, pack) {
        return {
            method: method,
            pack: pack,
            clue: clue_data.spot_index.get(method.for).for
        };
    }
    AugmentedMethod.create = create;
    function isSame(a, b) {
        return (a == b) || (a && b && LocalMethodId.equals(LocalMethodId.fromMethod(a), LocalMethodId.fromMethod(b)));
    }
    AugmentedMethod.isSame = isSame;
})(AugmentedMethod || (AugmentedMethod = {}));
